import React from 'react';

function VideoProgressBar({ progress }) {
  return (
    <div className="px-2">
      <div className="relative w-full h-1.5 bg-gray-200 mt-2 rounded-full overflow-hidden">
        <div
          className="absolute inset-y-0 w-1 bg-red-500 z-20 pointer-events-none"
          style={{
            left: `${progress}%`,
            transform: 'translateX(-50%)',
          }}
        />
      </div>
    </div>
  );
}

export default VideoProgressBar;
